import { axios } from '../../../services/axios';
import { VOUCHER_FILTER_TYPE } from '../../../views/voucher/create/VoucherFiltersEnum';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  data.minimum_subscription_duration = data?.filters?.find(
    (filter) => filter.type === VOUCHER_FILTER_TYPE.MINIMUM_SUBSCRIPTION_DURATION,
  )?.value;
  data.minimum_price_threshold = data?.filters?.find(
    (filter) => filter.type === VOUCHER_FILTER_TYPE.MINIMUM_PRICE_THRESHOLD,
  )?.value;

  dispatch({ type: CONST.VOUCHER_SHOW_SUCCESS, data: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.VOUCHER_SHOW_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const voucherShow = (id) => {
  return async (dispatch) => {
    dispatch({ type: CONST.VOUCHER_SHOW_REQUEST });

    axios.get(`/vouchers/${id}`).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
